import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";

export default class ReturnNotesSearchModel extends BaseModel {

  rules = {};

  attributeLabels = {};

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }

}

defineTranslatableProperties(ReturnNotesSearchModel);
